import { BaseService } from '/@/modules/core/app/services/abstracts/BaseService';
import CurrencyService from '/@/modules/predefined/services/CurrencyService';
import CountryService from '/@/modules/predefined/services/CountryService';
import JurisdictionService from '/@/modules/predefined/services/JurisdictionService';

export class PredefinedService extends BaseService {
  /**
   * @returns {Promise<(*|Array<Country>|Array<Jurisdiction>)[]>}
   */
  static onInit() {
    return Promise.all([
      CurrencyService.getItems({ active: true }),
      CountryService.getItems({ with: ['currency'] }),
      JurisdictionService.getItems()
    ]);
  }
}
